import EmptyListSplash from './EmptyListSplash'

export default EmptyListSplash
